import { FootchinkoItem } from "./FootchinkoItem";
import { GameVars } from "../../GameVars";
import { GameConstants } from "../../GameConstants";
import { MovingPlatformsManager } from "./MovingPlatformsManager";
import { AudioManager } from "../../AudioManager";

    export class MovingPlatform extends FootchinkoItem {

        // el delta de distancia del canto de la plataforma a los bordes del png
        // necesario pq tiene una sombra
        // el png tiene 85 x 45 px
        public static WIDTH: number = 85; // era 120
        public static HEIGHT: number = 46;
        public static TEXTURE_PACKER_PADDING: number = 2;

        public static EDGE_DX: number = 6;
        public static EDGE_DY: number = 6;

        public static SQUARE_DELTA_DISTANCE: number = 65 * 65;
        
        private static PLATFORM_SPEED: number = 55; 

        public px: number;
        public py: number;
        private velocity_x: number;
        private velocity_y: number;

        // TODO que wayIn sustituya a direction
        private wayIn: boolean;
        private direction: number;

        constructor(game: Phaser.Game, x: number, y: number, right: boolean, rotation: number) {
            // x + MovingPlatform.HEIGHT / 2 * Math.sin(rotation) - MovingPlatform.TEXTURE_PACKER_PADDING / 2 * Math.abs(Math.sin(rotation))
            super(game,
                x - MovingPlatform.EDGE_DX * Math.cos(rotation) + MovingPlatform.EDGE_DY * Math.sin(rotation) - MovingPlatform.TEXTURE_PACKER_PADDING / 2 * Math.abs(Math.sin(rotation)),
                y - MovingPlatform.EDGE_DY * Math.cos(rotation) - MovingPlatform.EDGE_DX * Math.sin(rotation) - MovingPlatform.TEXTURE_PACKER_PADDING / 2 * Math.abs(Math.cos(rotation)),
                "texture_atlas_1", true, false, rotation, right);

            this.canBeHit = true;

            this.px = this.x;
            this.py = this.y;

            this.wayIn = true;
        }

        public setBody(): void {

            this.body.setRectangle(68, 30 , 0, 0 );

            this.body.allowGravity = false;
            this.body.rotation = this.itemRotation;
            this.body.mass = 10e7;
            this.body.allowRotation = true;
            this.body.setZeroVelocity();

            this.body.data.type = Phaser.Physics.P2.Body.KINEMATIC;

            this.body.angularVelocity = 0;
            this.body.fixedRotation = false;
            this.body.setZeroDamping();

            this.body.setMaterial( GameVars.getInstance().materials.plankMaterial);

            this.velocity_x = Math.cos( this.itemRotation ) * MovingPlatform.PLATFORM_SPEED;
            this.velocity_y = Math.sin( this.itemRotation ) * MovingPlatform.PLATFORM_SPEED;

            this.direction = this.rightItem ? 1 : -1;

            this.body.velocity.x = this.direction * this.velocity_x ;
            this.body.velocity.y = this.direction * this.velocity_y ;
        }

        public setView(): void {

            super.setView();

            this.name = GameConstants.SOLID_PLANK;

            this.frameName = this.rightItem ? "moving-platform-right" : "moving-platform-left";

            this.burntFrameName = "burnt-mobile-plank";
        }

        public burn(): void {

            super.burn();

            MovingPlatformsManager.s_currentMovingPlatformsManager.platformBurnt(this);
        }

        public hasReachedLimit(): boolean {

            let d: number = (this.x - this.px) * (this.x - this.px) + (this.y - this.py) * (this.y - this.py);

            if (this.wayIn) {

                if (d > MovingPlatform.SQUARE_DELTA_DISTANCE ) {

                    this.wayIn = false;
                    return true;
                } else {
                    return false;
                }

            } else {

                if (d <  5 ) {
                    this.wayIn = true;
                    return true;
                } else {
                    return false;
                }
            }
        }

        public stop(): void {

            if (this.burnt) {
                return;
            }

            this.body.velocity.x = 0;
            this.body.velocity.y = 0;
        }

        public reverse(): void {

            if (this.burnt) {
                return;
            }

            this.direction = - this.direction;

            this.body.velocity.x = this.direction * this.velocity_x ;
            this.body.velocity.y = this.direction * this.velocity_y ;
        }

        public hit(): void {

            AudioManager.getInstance().playEffect("rebote_pin");
        }
    }
